import { VContainer } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VMain,[_c(VContainer,{staticStyle:{"max-width":"1400px"},attrs:{"fluid":""}},[_c('EndpointDetail',{attrs:{"endpoint":_vm.endpoint,"notFound":_vm.notFound}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }